import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=0bd634fa&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=0bd634fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd634fa",
  null
  
)

export default component.exports